/* Reliance — hero de l'accueil premium (sections/rel-home-hero.liquid).
   Slides en fondu, onglets nommés, flèches, clavier (← →), glisser sur mobile.
   Défilement auto : barre de progression sur l'onglet actif (animation CSS, dont la fin passe à la slide suivante) ;
   pause au survol, au focus, onglet masqué ; jamais si « réduire les animations ».
   Sans JS : la 1re slide reste seule visible. */
(function () {
  function init(root) {
    if (root.dataset.relHomeReady) return;
    root.dataset.relHomeReady = '1';

    // Sur ordinateur, remplir l'écran sous le header réellement rendu.
    function syncHeight() {
      var top = root.getBoundingClientRect().top + window.scrollY;
      root.style.setProperty('--rel-home-hero-top', Math.max(0, top) + 'px');
    }
    syncHeight();
    window.addEventListener('resize', syncHeight);
    var headerObserver = window.ResizeObserver ? new ResizeObserver(syncHeight) : null;
    if (headerObserver) {
      document.querySelectorAll('[class*="section-group"][class*="header-group"]').forEach(function (header) {
        headerObserver.observe(header);
      });
    }
    function unload(event) {
      if (!event.target.contains(root)) return;
      window.removeEventListener('resize', syncHeight);
      if (headerObserver) headerObserver.disconnect();
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rel-home-slide]'));
    var nav = root.querySelector('[data-rel-home-nav]');
    if (slides.length < 2 || !nav) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-rel-home-tab]'));
    var mobileProgress = root.querySelector('[data-rel-home-mobile-progress]');
    var mobileLabel = root.querySelector('[data-rel-home-mobile-label]');
    var mobileTabs = Array.prototype.slice.call(root.querySelectorAll('[data-rel-home-mobile-tab]'));
    var mobileBars = Array.prototype.slice.call(root.querySelectorAll('[data-rel-home-mobile-bar]'));
    var status = root.querySelector('[data-rel-home-status]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.dataset.autoplay === 'true' && !reduce;
    var delay = (parseInt(root.dataset.speed, 10) || 7) * 1000;
    var current = 0;
    var paused = false;

    nav.hidden = false;
    if (mobileProgress) mobileProgress.hidden = false;
    if (autoplay) {
      root.setAttribute('data-progress', '');
      root.style.setProperty('--rel-home-hero-delay', delay + 'ms');
    }

    function show(index, announce) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.hidden = !active;
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });
      tabs.forEach(function (tab, i) {
        tab.setAttribute('aria-pressed', i === current ? 'true' : 'false');
      });
      mobileTabs.forEach(function (tab, i) {
        tab.setAttribute('aria-pressed', i === current ? 'true' : 'false');
      });
      if (mobileLabel) mobileLabel.textContent = tabs[current].querySelector('.rel-home-hero__tab-label').textContent;
      if (announce && status) status.textContent = slides[current].getAttribute('aria-label') || '';
    }

    function syncPause() {
      root.classList.toggle('is-paused', paused || document.hidden);
    }

    function stop() {
      paused = true;
      syncPause();
    }

    function resume() {
      paused = false;
      syncPause();
    }

    // Relance la barre de l'onglet actif depuis zéro.
    function start() {
      if (!autoplay) return;
      tabs.forEach(function (tab) {
        tab.classList.remove('is-running');
      });
      mobileBars.forEach(function (bar) { bar.classList.remove('is-running'); });
      void root.offsetWidth;
      tabs[current].classList.add('is-running');
      if (mobileBars[current]) mobileBars[current].classList.add('is-running');
    }

    if (autoplay) {
      root.addEventListener('animationend', function (event) {
        if (!event.target.classList.contains('rel-home-hero__tab-bar') && !event.target.classList.contains('rel-home-hero__mobile-bar')) return;
        // Ignorer la barre masquée de l'autre format et les anciennes animations.
        if (!event.target.getClientRects().length || !event.target.closest('[aria-pressed="true"]')) return;
        show(current + 1, false);
        start();
      });
      document.addEventListener('visibilitychange', syncPause);
    }

    tabs.concat(mobileTabs).forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.hasAttribute('data-rel-home-tab') ? tab.dataset.relHomeTab : tab.dataset.relHomeMobileTab;
        show(parseInt(index, 10), true);
        start();
      });
    });

    root.querySelector('[data-rel-home-prev]').addEventListener('click', function () {
      show(current - 1, true);
      start();
    });
    root.querySelector('[data-rel-home-next]').addEventListener('click', function () {
      show(current + 1, true);
      start();
    });

    root.addEventListener('keydown', function (event) {
      if (event.target !== root) return;
      if (event.key === 'ArrowLeft') {
        show(current - 1, true);
        start();
      } else if (event.key === 'ArrowRight') {
        show(current + 1, true);
        start();
      }
    });

    var startX = null;
    root.addEventListener('touchstart', function (event) {
      startX = event.touches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var dx = event.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) < 50) return;
      show(dx < 0 ? current + 1 : current - 1, true);
      start();
    }, { passive: true });

    ['mouseenter', 'focusin'].forEach(function (type) {
      root.addEventListener(type, stop);
    });
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusout', function (event) {
      if (root.contains(event.relatedTarget)) return;
      resume();
    });

    // Éditeur de thème : afficher la slide sélectionnée.
    document.addEventListener('shopify:block:select', function (event) {
      var i = slides.indexOf(event.target);
      if (i === -1) return;
      stop();
      show(i, false);
      start();
    });

    show(current, false);
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-rel-home-hero]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
